import React, { useState, useContext, useEffect } from "react";
import CommonAccordion from "../../custom-components/CommonAccordion";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Radio,
  Box,
  Button,
  Typography,
  styled,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import { generateFeatureFileToolCalling } from "../../../services/webServices";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { use } from "react";

const BorderedTableCell = styled(TableCell)(({ theme }) => ({
  border: "1px solid rgba(224, 224, 224, 1)",
}));

const BorderedTableHeadCell = styled(TableCell)(({ theme }) => ({
  border: "1px solid rgba(224, 224, 224, 1)",
  backgroundColor: theme.palette.action.hover,
}));

export default function ChooseTestCase(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoadingState } = useContext(LoadingModalContext);
  const [testCases, setTestCases] = useState(props.testCaseData || []);
  const [selectedTestCaseradio, setselectedTestCaseradio] = useState(null);
  const [selectedTestCase, setselectedTestCase] = useState(null);;
  const [buttondisable, setbuttondisable] = useState(true);
  const [featureFileData, setfeatureFileData] = useState("");
  const defaultLocatorsExpanded = true
  // props.generateTestCasesData.length > 0 &&
  // featureFileData === "";

  useEffect(() => {

    setTestCases(location.state?.testCaseData);
  }, [location.state.testCaseData]);
  const handleTestCaseChange = (event) => {
    const index = parseInt(event.target.value, 10);
    setselectedTestCaseradio(index);
    setselectedTestCase(testCases[index]);

    setbuttondisable(false);
  };

const isFunctionalTestCase = (testCase) => {
  return testCase.Category && testCase.Category.startsWith("Functional");
};
  // const handleGenerateFeatureFile = async () => {
  //   let fake;
  //   const startProgress = (setProgress) => {
  //     let progress = 0;
  //     let stop = false;
  //     let finalMessageShown = false;

  //     const interval = setInterval(() => {
  //       if (stop) return;

  //       progress += 2.4;
  //       if (progress >= 98 && !finalMessageShown) {
  //         finalMessageShown = true;
  //         setLoadingState((prev) => ({
  //           ...prev,
  //           message: "Almost done! Fetching your output",
  //         }));
  //       }

  //       if (progress >= 98) progress = 98;

  //       setProgress((prev) => ({
  //         ...prev,
  //         progress: Math.max(prev.progress, Math.floor(progress)),
  //       }));
  //     }, 200);

  //     return {
  //       stop: () => {
  //         stop = true;
  //         clearInterval(interval);
  //       },
  //       completeTo100: async () => {
  //         stop = true;
  //         clearInterval(interval);

  //         // Rush to 100%
  //         setProgress((prev) => ({
  //           ...prev,
  //           progress: 100,
  //         }));
  //         await new Promise((res) => setTimeout(res, 500));
  //       },
  //     };
  //   };

  //   const finishTo100AndClose = async () => {
  //     await fake.completeTo100();
  //     setLoadingState({ open: false, message: "", progress: null });
  //   };
  //   // Initial message
  //   setLoadingState({
  //     open: true,
  //     message: "Generating Feature File",
  //     progress: 0,
  //   });

  //   fake = startProgress(setLoadingState);

  //   try {
  //     const featureData = await generateFeatureFileToolCalling(
  //       selectedTestCase
  //     );
  //     const featureFileData = featureData.data;
  //     setfeatureFileData(featureFileData);
  //     await finishTo100AndClose();
  //     navigate(`/dashboard/api-testing/${props.framework}`, {
  //       state: { ...location.state, featureFileData: featureFileData, selectedTestCaseData: selectedTestCase },
  //     });
  //   } catch (error) {
  //     console.error("Error generating feature file:", error);
  //     setLoadingState({ open: false, message: "", progress: null });
  //   } finally {
  //     setLoadingState({ open: false, message: "", progress: null });
  //   }
  // };

  const handlesSelectConfiguration = () => {
    navigate(`/dashboard/api-testing/api-automation`, {
      state: { selectedTestCaseData: selectedTestCase },
    });
  }


  const renderInputData = (inputData) => {
    if (!inputData || Object.keys(inputData).length === 0) {
      return "No input data";
    }
    if (typeof inputData === 'object') {
      return JSON.stringify(inputData, null, 2);
    }
    return inputData;
  };

  const buttonsgroup = [
    {
      // sx: { float: "right" },
      label: "Configure",
      variant: "contained",
      onClick: handlesSelectConfiguration,
      // disabled: buttondisable,
      disabled: buttondisable,
      // startIcon: <GenerateButtonIcon />,
    },
  ];

  const detailsContent = (

    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Test Cases
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Select functional test cases only.
      </Typography>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ mb: 3, border: "1px solid rgba(224, 224, 224, 1)" }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <BorderedTableHeadCell
                width="60px"
                align="center"
              ></BorderedTableHeadCell>
              <BorderedTableHeadCell>Test Case ID</BorderedTableHeadCell>
              <BorderedTableHeadCell>Test Case Title</BorderedTableHeadCell>
              <BorderedTableHeadCell>API Endpoint</BorderedTableHeadCell>
              <BorderedTableHeadCell>Method</BorderedTableHeadCell>
              <BorderedTableHeadCell>Test Description</BorderedTableHeadCell>
              <BorderedTableHeadCell>Test Steps</BorderedTableHeadCell>
              <BorderedTableHeadCell>Input Data</BorderedTableHeadCell>
              <BorderedTableHeadCell>Expected Result</BorderedTableHeadCell>
              <BorderedTableHeadCell>Category</BorderedTableHeadCell>
              <BorderedTableCell>Sub-Category</BorderedTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {testCases.map((testCase, index) =>
              testCase.Category.startsWith('Functional') && (
                <TableRow
                  key={index}
                  hover
                  selected={selectedTestCaseradio === index}
                >
                  <BorderedTableCell align="center">
                    <Radio
                      checked={selectedTestCaseradio === index}
                      onChange={handleTestCaseChange}
                      value={index}
                      name="test-case-radio"
                      size="small"
                      color="primary"
                    />
                  </BorderedTableCell>
                  <BorderedTableCell>{testCase["Test Case ID"]}</BorderedTableCell>
                  <BorderedTableCell>{testCase["Test Case Title"]}</BorderedTableCell>
                  <BorderedTableCell>{testCase["API Endpoint"]}</BorderedTableCell>
                  <BorderedTableCell>{testCase["Method"]}</BorderedTableCell>
                  <BorderedTableCell>
                    {testCase["Test Description"]}
                  </BorderedTableCell>
                  <BorderedTableCell>{testCase["Test Steps"]}</BorderedTableCell>
                  {/* <BorderedTableCell>{testCase.InputData}</BorderedTableCell> */}
                  <BorderedTableCell>
                    {renderInputData(testCase["Input Data"])}

                  </BorderedTableCell>
                  <BorderedTableCell>{testCase["Expected Result"]}</BorderedTableCell>
                  <BorderedTableCell>{testCase["Category"]}</BorderedTableCell>
                  <BorderedTableCell>{testCase["Sub-Category"]}</BorderedTableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
{!testCases.some(isFunctionalTestCase) &&(
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography variant="body1"> </Typography>
        
        </Box>
)}

    </Box>
  );

  return (
    <Box
      sx={{

        display: "flex",
        bgcolor: "#f6f3f2",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "auto",
        width: "100%",
        // height: "80vh",
        minHeight: "80vh",
        //position: "relative",
        paddingTop: "4vh",
        paddingBottom: "5vh",

      }}
    >
      <Box
        sx={{
          width: {
            xs: "95%",   // small screens
            sm: "90%",
            md: "90%",
            lg: "90%",   // reduce width on larger screens
            xl: "90%",
          },
          maxWidth: "1400px", // maximum width for larger screens

        }}
      >
        <CommonAccordion
          summary="Choose Test Case"
          type={"output"}
          details={detailsContent}
          // buttons={buttonsgroup}
          buttons={buttonsgroup}
          fullScreenMode={true}
          defaultExpanded={defaultLocatorsExpanded}

        />
      </Box>
    </Box>
  );
}
